module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_location_sola-1d8d70ce44cc18581ac875c35e503e98.webp";